module.exports = __webpack_public_path__ + "img/Chipssummit-white.eb79e94b.svg";